import { useMe } from '../api/me';

export function useCanManualSync(): boolean {
  const { data } = useMe();
  return data?.isAdmin === true;
}
